import dateSchema from './dateSchema';

export default (preTag) => ({
  blocks: {
    [preTag]: dateSchema,
  },
});
